import {
  Companion_getInstanceh1cmko92158x as Companion_getInstance,
  Dispute39kejofcwuxch as Dispute,
  DisputeState_Ongoing_getInstance2zn99spsjy3fz as DisputeState_Ongoing_getInstance,
  DisputeState3oxdvb7g0kfjm as DisputeState,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  LineItemDispute2w87ksbqzbvuq as LineItemDispute,
  AccessInfoj60d6hx1qs8r as AccessInfo,
  FiledForArbitrationrkri4vx0h6kh as FiledForArbitration,
} from './supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_incident(_this__u8e3s4) {
  return _this__u8e3s4.prop(Dispute_incident_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(Dispute_state_getInstance());
}
function get_lineItem(_this__u8e3s4) {
  return _this__u8e3s4.prop(Dispute_lineItem_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(Dispute_project_getInstance());
}
function prepareDisputeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Dispute__id_getInstance(), Dispute_project_getInstance(), Dispute_lineItem_getInstance(), Dispute_incident_getInstance(), Dispute_filed_getInstance(), Dispute_lockProject_getInstance(), Dispute_filedForArbitration_getInstance(), Dispute_resolved_getInstance(), Dispute_readBy_getInstance(), Dispute_state_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Dispute_incident$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Dispute_incident$_get_name_$ref_tkaa2i() {
  return (p0) => p0.k20();
}
function Dispute_incident$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_incident$_get_serializer_$ref_optc0x() {
  return (p0) => p0.j2j();
}
function Dispute_incident$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Dispute_incident$_get_annotations_$ref_zptkr() {
  return (p0) => p0.bz();
}
var Dispute_incidentClass;
function Dispute_incident() {
  if (Dispute_incidentClass === VOID) {
    class $ {
      constructor() {
        Dispute_incident_instance = this;
        var tmp = this;
        tmp.e5w_1 = lazy(Dispute_incident$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f5w_1 = lazy(Dispute_incident$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g5w_1 = lazy(Dispute_incident$annotations$delegate$lambda);
        this.h5w_1 = null;
        this.i5w_1 = 'null';
      }
      k20() {
        var tmp0 = this.e5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_incident$_get_name_$ref_tkaa2i(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.n5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      u5w(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.u5w(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_incident$_get_serializer_$ref_optc0x(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_incident$_get_annotations_$ref_zptkr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_incident', VOID, VOID, [SerializableProperty()]);
    Dispute_incidentClass = $;
  }
  return Dispute_incidentClass;
}
var Dispute_incident_instance;
function Dispute_incident_getInstance() {
  if (Dispute_incident_instance === VOID)
    new (Dispute_incident())();
  return Dispute_incident_instance;
}
function Dispute_state$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function Dispute_state$_get_name_$ref_f6g3lp() {
  return (p0) => p0.k20();
}
function Dispute_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_state$_get_serializer_$ref_gut93q() {
  return (p0) => p0.j2j();
}
function Dispute_state$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function Dispute_state$_get_annotations_$ref_97pdv2() {
  return (p0) => p0.bz();
}
var Dispute_stateClass;
function Dispute_state() {
  if (Dispute_stateClass === VOID) {
    class $ {
      constructor() {
        Dispute_state_instance = this;
        var tmp = this;
        tmp.w5w_1 = lazy(Dispute_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x5w_1 = lazy(Dispute_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y5w_1 = lazy(Dispute_state$annotations$delegate$lambda);
        this.z5w_1 = DisputeState_Ongoing_getInstance();
        this.a5x_1 = 'DisputeState.Ongoing';
      }
      k20() {
        var tmp0 = this.w5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_state$_get_name_$ref_f6g3lp(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.t5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      b5x(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.b5x(tmp, value instanceof DisputeState() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_state$_get_serializer_$ref_gut93q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y5w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_state$_get_annotations_$ref_97pdv2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_state', VOID, VOID, [SerializableProperty()]);
    Dispute_stateClass = $;
  }
  return Dispute_stateClass;
}
var Dispute_state_instance;
function Dispute_state_getInstance() {
  if (Dispute_state_instance === VOID)
    new (Dispute_state())();
  return Dispute_state_instance;
}
function Dispute_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Dispute_lineItem$_get_name_$ref_uhxx0v() {
  return (p0) => p0.k20();
}
function Dispute_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_lineItem$_get_serializer_$ref_spe5d6() {
  return (p0) => p0.j2j();
}
function Dispute_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Dispute_lineItem$_get_annotations_$ref_le4w4a() {
  return (p0) => p0.bz();
}
var Dispute_lineItemClass;
function Dispute_lineItem() {
  if (Dispute_lineItemClass === VOID) {
    class $ {
      constructor() {
        Dispute_lineItem_instance = this;
        var tmp = this;
        tmp.c5x_1 = lazy(Dispute_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d5x_1 = lazy(Dispute_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e5x_1 = lazy(Dispute_lineItem$annotations$delegate$lambda);
        this.f5x_1 = null;
        this.g5x_1 = 'null';
      }
      k20() {
        var tmp0 = this.c5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_lineItem$_get_name_$ref_uhxx0v(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.m5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      h5x(receiver, value) {
        return receiver.v5w(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.h5x(tmp, (value == null ? true : value instanceof LineItemDispute()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_lineItem$_get_serializer_$ref_spe5d6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_lineItem$_get_annotations_$ref_le4w4a(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_lineItem', VOID, VOID, [SerializableProperty()]);
    Dispute_lineItemClass = $;
  }
  return Dispute_lineItemClass;
}
var Dispute_lineItem_instance;
function Dispute_lineItem_getInstance() {
  if (Dispute_lineItem_instance === VOID)
    new (Dispute_lineItem())();
  return Dispute_lineItem_instance;
}
function Dispute_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Dispute_project$_get_name_$ref_p5s4c5() {
  return (p0) => p0.k20();
}
function Dispute_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_project$_get_serializer_$ref_fulyq6() {
  return (p0) => p0.j2j();
}
function Dispute_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Dispute_project$_get_annotations_$ref_lykjt6() {
  return (p0) => p0.bz();
}
var Dispute_projectClass;
function Dispute_project() {
  if (Dispute_projectClass === VOID) {
    class $ {
      constructor() {
        Dispute_project_instance = this;
        var tmp = this;
        tmp.i5x_1 = lazy(Dispute_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j5x_1 = lazy(Dispute_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k5x_1 = lazy(Dispute_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.i5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_project$_get_name_$ref_p5s4c5(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.l5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      l5x(receiver, value) {
        return receiver.v5w(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.l5x(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_project$_get_serializer_$ref_fulyq6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_project$_get_annotations_$ref_lykjt6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_project', VOID, VOID, [SerializableProperty()]);
    Dispute_projectClass = $;
  }
  return Dispute_projectClass;
}
var Dispute_project_instance;
function Dispute_project_getInstance() {
  if (Dispute_project_instance === VOID)
    new (Dispute_project())();
  return Dispute_project_instance;
}
function Dispute__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Dispute__id$_get_name_$ref_n13o0c() {
  return (p0) => p0.k20();
}
function Dispute__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute__id$_get_serializer_$ref_kb91fx() {
  return (p0) => p0.j2j();
}
function Dispute__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Dispute__id$_get_annotations_$ref_poxbl5() {
  return (p0) => p0.bz();
}
var Dispute__idClass;
function Dispute__id() {
  if (Dispute__idClass === VOID) {
    class $ {
      constructor() {
        Dispute__id_instance = this;
        var tmp = this;
        tmp.m5x_1 = lazy(Dispute__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5x_1 = lazy(Dispute__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5x_1 = lazy(Dispute__id$annotations$delegate$lambda);
        this.p5x_1 = Companion_getInstance_0().m2p();
        this.q5x_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.m5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute__id$_get_name_$ref_n13o0c(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.k5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      l5x(receiver, value) {
        return receiver.v5w(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.l5x(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute__id$_get_serializer_$ref_kb91fx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute__id$_get_annotations_$ref_poxbl5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute__id', VOID, VOID, [SerializableProperty()]);
    Dispute__idClass = $;
  }
  return Dispute__idClass;
}
var Dispute__id_instance;
function Dispute__id_getInstance() {
  if (Dispute__id_instance === VOID)
    new (Dispute__id())();
  return Dispute__id_instance;
}
function Dispute_filed$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Dispute_filed$_get_name_$ref_w5tfnq() {
  return (p0) => p0.k20();
}
function Dispute_filed$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_filed$_get_serializer_$ref_trk2cf() {
  return (p0) => p0.j2j();
}
function Dispute_filed$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Dispute_filed$_get_annotations_$ref_grvri3() {
  return (p0) => p0.bz();
}
var Dispute_filedClass;
function Dispute_filed() {
  if (Dispute_filedClass === VOID) {
    class $ {
      constructor() {
        Dispute_filed_instance = this;
        var tmp = this;
        tmp.r5x_1 = lazy(Dispute_filed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5x_1 = lazy(Dispute_filed$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5x_1 = lazy(Dispute_filed$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_filed$_get_name_$ref_w5tfnq(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.o5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      u5x(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.u5x(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_filed$_get_serializer_$ref_trk2cf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_filed$_get_annotations_$ref_grvri3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_filed', VOID, VOID, [SerializableProperty()]);
    Dispute_filedClass = $;
  }
  return Dispute_filedClass;
}
var Dispute_filed_instance;
function Dispute_filed_getInstance() {
  if (Dispute_filed_instance === VOID)
    new (Dispute_filed())();
  return Dispute_filed_instance;
}
function Dispute_lockProject$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Dispute_lockProject$_get_name_$ref_z0k9ds() {
  return (p0) => p0.k20();
}
function Dispute_lockProject$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_lockProject$_get_serializer_$ref_jbd7dz() {
  return (p0) => p0.j2j();
}
function Dispute_lockProject$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Dispute_lockProject$_get_annotations_$ref_ody28b() {
  return (p0) => p0.bz();
}
var Dispute_lockProjectClass;
function Dispute_lockProject() {
  if (Dispute_lockProjectClass === VOID) {
    class $ {
      constructor() {
        Dispute_lockProject_instance = this;
        var tmp = this;
        tmp.v5x_1 = lazy(Dispute_lockProject$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5x_1 = lazy(Dispute_lockProject$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5x_1 = lazy(Dispute_lockProject$annotations$delegate$lambda);
        this.y5x_1 = null;
        this.z5x_1 = 'null';
      }
      k20() {
        var tmp0 = this.v5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_lockProject$_get_name_$ref_z0k9ds(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.p5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      a5y(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.a5y(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_lockProject$_get_serializer_$ref_jbd7dz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_lockProject$_get_annotations_$ref_ody28b(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_lockProject', VOID, VOID, [SerializableProperty()]);
    Dispute_lockProjectClass = $;
  }
  return Dispute_lockProjectClass;
}
var Dispute_lockProject_instance;
function Dispute_lockProject_getInstance() {
  if (Dispute_lockProject_instance === VOID)
    new (Dispute_lockProject())();
  return Dispute_lockProject_instance;
}
function Dispute_filedForArbitration$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Dispute_filedForArbitration$_get_name_$ref_alo8i8() {
  return (p0) => p0.k20();
}
function Dispute_filedForArbitration$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_filedForArbitration$_get_serializer_$ref_8v8tzd() {
  return (p0) => p0.j2j();
}
function Dispute_filedForArbitration$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Dispute_filedForArbitration$_get_annotations_$ref_pbjgyt() {
  return (p0) => p0.bz();
}
var Dispute_filedForArbitrationClass;
function Dispute_filedForArbitration() {
  if (Dispute_filedForArbitrationClass === VOID) {
    class $ {
      constructor() {
        Dispute_filedForArbitration_instance = this;
        var tmp = this;
        tmp.b5y_1 = lazy(Dispute_filedForArbitration$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5y_1 = lazy(Dispute_filedForArbitration$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5y_1 = lazy(Dispute_filedForArbitration$annotations$delegate$lambda);
        this.e5y_1 = null;
        this.f5y_1 = 'null';
      }
      k20() {
        var tmp0 = this.b5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_filedForArbitration$_get_name_$ref_alo8i8(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.q5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      g5y(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.g5y(tmp, (value == null ? true : value instanceof FiledForArbitration()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_filedForArbitration$_get_serializer_$ref_8v8tzd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_filedForArbitration$_get_annotations_$ref_pbjgyt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_filedForArbitration', VOID, VOID, [SerializableProperty()]);
    Dispute_filedForArbitrationClass = $;
  }
  return Dispute_filedForArbitrationClass;
}
var Dispute_filedForArbitration_instance;
function Dispute_filedForArbitration_getInstance() {
  if (Dispute_filedForArbitration_instance === VOID)
    new (Dispute_filedForArbitration())();
  return Dispute_filedForArbitration_instance;
}
function Dispute_resolved$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function Dispute_resolved$_get_name_$ref_g11qqo() {
  return (p0) => p0.k20();
}
function Dispute_resolved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_resolved$_get_serializer_$ref_825yt5() {
  return (p0) => p0.j2j();
}
function Dispute_resolved$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function Dispute_resolved$_get_annotations_$ref_ko3qnf() {
  return (p0) => p0.bz();
}
var Dispute_resolvedClass;
function Dispute_resolved() {
  if (Dispute_resolvedClass === VOID) {
    class $ {
      constructor() {
        Dispute_resolved_instance = this;
        var tmp = this;
        tmp.h5y_1 = lazy(Dispute_resolved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5y_1 = lazy(Dispute_resolved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5y_1 = lazy(Dispute_resolved$annotations$delegate$lambda);
        this.k5y_1 = null;
        this.l5y_1 = 'null';
      }
      k20() {
        var tmp0 = this.h5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_resolved$_get_name_$ref_g11qqo(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.r5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      a5y(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.a5y(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_resolved$_get_serializer_$ref_825yt5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_resolved$_get_annotations_$ref_ko3qnf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_resolved', VOID, VOID, [SerializableProperty()]);
    Dispute_resolvedClass = $;
  }
  return Dispute_resolvedClass;
}
var Dispute_resolved_instance;
function Dispute_resolved_getInstance() {
  if (Dispute_resolved_instance === VOID)
    new (Dispute_resolved())();
  return Dispute_resolved_instance;
}
function Dispute_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function Dispute_readBy$_get_name_$ref_y90fcb() {
  return (p0) => p0.k20();
}
function Dispute_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Dispute_readBy$_get_serializer_$ref_pwvtxg() {
  return (p0) => p0.j2j();
}
function Dispute_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function Dispute_readBy$_get_annotations_$ref_5vh3k0() {
  return (p0) => p0.bz();
}
var Dispute_readByClass;
function Dispute_readBy() {
  if (Dispute_readByClass === VOID) {
    class $ {
      constructor() {
        Dispute_readBy_instance = this;
        var tmp = this;
        tmp.m5y_1 = lazy(Dispute_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5y_1 = lazy(Dispute_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5y_1 = lazy(Dispute_readBy$annotations$delegate$lambda);
        this.p5y_1 = emptySet();
        this.q5y_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.m5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Dispute_readBy$_get_name_$ref_y90fcb(), null);
        return tmp0.f2();
      }
      j5w(receiver) {
        return receiver.s5w_1;
      }
      m2j(receiver) {
        return this.j5w(receiver instanceof Dispute() ? receiver : THROW_CCE());
      }
      r5y(receiver, value) {
        return receiver.v5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Dispute() ? receiver : THROW_CCE();
        return this.r5y(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Dispute_readBy$_get_serializer_$ref_pwvtxg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Dispute_readBy$_get_annotations_$ref_5vh3k0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Dispute_readBy', VOID, VOID, [SerializableProperty()]);
    Dispute_readByClass = $;
  }
  return Dispute_readByClass;
}
var Dispute_readBy_instance;
function Dispute_readBy_getInstance() {
  if (Dispute_readBy_instance === VOID)
    new (Dispute_readBy())();
  return Dispute_readBy_instance;
}
//region block: exports
export {
  get_incident as get_incident3rzbe1tjdx6x3,
  get_lineItem as get_lineItem5qsvgygh297v,
  prepareDisputeFields as prepareDisputeFields1rkdlu6hnhzr7,
  get_project as get_project340dxjn5izj1d,
  get_state as get_state1140xg7i4ysgd,
};
//endregion

//# sourceMappingURL=DisputeFields.mjs.map
